import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { i18nObject } from 'boot/i18n'
import { useSystemStore } from 'src/stores/system'

export const useMainStore = defineStore('main', () => {
  const info = ref({})

  const a_ssid = ref('')
  const app_type = ref('')
  const mb_uuid = ref('')
  const app_id = ref('')

  const systemStore = useSystemStore()

  const getMainGroups = computed(() => {
    const groups = [
      {
        slug: 'slot',
        label: i18nObject.global.t('slots'),
        name: 'GamesByGroup',
      },
      {
        slug: 'online',
        label: i18nObject.global.t('live_casino'),
        name: 'GamesByGroup',
      },
      {
        slug: 'fast',
        label: i18nObject.global.t('instant'),
        name: 'GamesByGroup',
      },
      {
        slug: 'table',
        label: i18nObject.global.t('table'),
        name: 'GamesByGroup',
      },
      {
        slug: 'lottery',
        label: i18nObject.global.t('lottery'),
        name: 'GamesByGroup',
      },
      {
        slug: 'vsport',
        label: i18nObject.global.t('virtuals'),
        name: 'GamesByGroup',
      },
      {
        slug: 'new',
        label: i18nObject.global.t('new'),
        name: 'GamesByGroup',
      },
    ]

    //для olymp и olimp - убираем table и vsport, добавляется new
    if (systemStore.main || systemStore.alt) {
      return groups.filter((group) => !['table', 'vsport'].includes(group.slug))
    }

    // Для olimpbet (altW) убираем группы lottery, table vsport, добавляется new
    if (systemStore.altW) {
      return groups.filter((group) => !['lottery', 'table', 'vsport'].includes(group.slug))
    }

    return groups
  })

  const getAssid = computed(() => {
    return a_ssid.value || localStorage?.getItem('a_ssid') || sessionStorage.getItem('a_ssid') || ''
  })
  const getAppType = computed(() => {
    return app_type.value || localStorage?.getItem('app_type') || sessionStorage.getItem('app_type') || null
  })
  const getMbUuid = computed(() => {
    return mb_uuid.value || localStorage?.getItem('mb_uuid') || sessionStorage.getItem('mb_uuid') || null
  })
  const getAppId = computed(() => {
    return app_id.value || localStorage?.getItem('app_id') || sessionStorage.getItem('app_id') || null
  })

  function clear() {
    a_ssid.value = ''
    app_type.value = ''
    mb_uuid.value = ''
    app_id.value = ''
    if (localStorage) {
      localStorage.removeItem('a_ssid')
      localStorage.removeItem('app_type')
      localStorage.removeItem('mb_uuid')
      localStorage.removeItem('app_id')
    }
    if (sessionStorage) {
      sessionStorage.removeItem('a_ssid')
      sessionStorage.removeItem('app_type')
      sessionStorage.removeItem('mb_uuid')
      sessionStorage.removeItem('app_id')
    }
  }

  function updateAssid(payload) {
    a_ssid.value = payload
    if (localStorage) {
      localStorage.setItem('a_ssid', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('a_ssid', payload)
    }
  }

  function updateAppType(payload) {
    app_type.value = payload
    if (localStorage) {
      localStorage.setItem('app_type', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('app_type', payload)
    }
  }

  function updateMbUuid(payload) {
    mb_uuid.value = payload
    if (localStorage) {
      localStorage.setItem('mb_uuid', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('mb_uuid', payload)
    }
  }

  function updateAppId(payload) {
    app_id.value = payload
    if (localStorage) {
      localStorage.setItem('app_id', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('app_id', payload)
    }
  }

  return {
    info,
    a_ssid,
    app_type,
    mb_uuid,
    app_id,
    getMainGroups,
    getAssid,
    getAppType,
    getMbUuid,
    getAppId,
    clear,
    updateAssid,
    updateAppType,
    updateMbUuid,
    updateAppId,
  }
})
